import { render, staticRenderFns } from "./ServiceGroupItem.vue?vue&type=template&id=652dcc27&scoped=true&"
import script from "./ServiceGroupItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceGroupItem.vue?vue&type=style&index=0&id=652dcc27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652dcc27",
  null
  
)

export default component.exports